import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "securing-web-actions"
    }}>{`Securing Web Actions`}</h1>
    <p>{`By default, a web action can be invoked by anyone knowing the action`}{`’`}{`s URL. If you want to restrict the access, you either use Basic Authentication or you build your own authentication layer.`}</p>
    <h2 {...{
      "id": "basic-authentication"
    }}>{`Basic Authentication`}</h2>
    <p>{`Here is how you can enable Basic Authentication for a web action:`}</p>
    <pre><code parentName="pre" {...{}}>{`// create a web action with Basic Authentication on
aio rt:action:create my-secure-web-action main.js --web true --web-secure this-is-the-secret-hash
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{}}>{`// update an existing web action to enable Basic Authenticationn or change the secret
aio rt:action:update my-secure-web-action main.js --web true --web-secure this-is-the-secret-hash
`}</code></pre>
    <p>{`Once you`}{`’`}{`ve enabled Basic Authentication, you`}{`’`}{`ll have to pass `}<em parentName="p">{`X-Require-Wisk-Auth`}</em>{` header, and the secret you set, when invoking the web action. Assuming that your web action is created in the default package, this is how you`}{`’`}{`ll invoke it:`}</p>
    <pre><code parentName="pre" {...{}}>{`curl -X GET -H "X-Require-Whisk-Auth: <this-is-the-secret-hash>" https://[your-namespaces].adobeioruntime.net/api/v1/web/default/my-secure-web-action
`}</code></pre>
    <p>{`If you fail in adding the authentication header or the secret is wrong, you will get an error:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
  "error": "Authentication is possible but has failed or not yet been provided.",
  "code": "OWGYkWwCUT7Ta6hWpfZWTQqRsfvcFTku"
}
`}</code></pre>
    <h2 {...{
      "id": "oauth-using-the-adobe-identity-management-system"
    }}>{`Oauth (using the Adobe Identity Management System)`}</h2>
    <p>{`Here is how you can enable IMS Authentication for a web action:`}</p>
    <pre><code parentName="pre" {...{}}>{`// create a web action with Require Validation on
aio rt:action:create my-requir-validation-web-action main.js --web true -a require-gw-validation true
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{}}>{`// update an existing web action to enable Require Validation
aio rt:action:update my-require-validation-web-action main.js --web true -a require-gw-validation true
`}</code></pre>
    <p>{`To interact with the action, it's necessary to set up a security configuration in your Swagger API route for that action. Detailed instructions on how to do this can be found in the documentation titled "`}<a parentName="p" {...{
        "href": "https://developer.adobe.com/runtime/docs/guides/using/creating_rest_apis/#securing-the-api-endpoints"
      }}>{`Securing the API Endpoints`}</a>{`.".  `}</p>
    <h1 {...{
      "id": "non-web-actions"
    }}>{`Non Web Actions`}</h1>
    <p>{`If your action is not a web action, you can still use your namespace credentials, base64 encoded, to call any of the actions in your namespace, as follows:`}</p>
    <pre><code parentName="pre" {...{}}>{`curl -X POST -H "Authorization: Basic <base64-namepsace-auth>" https://[your-namespaces].adobeioruntime.net/api/v1/default/my-secure-action
`}</code></pre>
    <h2 {...{
      "id": "cookies"
    }}>{`Cookies`}</h2>
    <p>{`The use of cookies directly from web actions on Runtime is discouraged. The reason for this is that, due to the shared nature of the infrastructure, it is not possible to completely segregate cookies between namespaces. It is okay to use the runtime domain for testing, but any cookie set directly by the runtime domain must be considered compromised.`}</p>
    <p>{`To alleviate this, you can set up a forwarding proxy with a correct and valid second-level domain and send those requests along to the actual runtime domain. Inside your function, you can then implement an approve list or some shared secret to ensure that people attempting to access the functions directly are denied. Adobe also provides Container Native Applications, which can do much of this work for you.`}</p>
    <p>{`For a fuller discussion of this topic you can read `}<a parentName="p" {...{
        "href": "https://devcenter.heroku.com/articles/cookies-and-herokuapp-com"
      }}>{`Heroku`}{`’`}{`s discussion of their cookie policy`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      